// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Comment(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Comment" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V21L17 17H4C3.44772 17 3 16.5523 3 16V4Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Comment.js.map